import React from 'react';
import { Wallet, LayoutList } from 'lucide-react';

interface TokenTabsProps {
  activeTab: 'wallets' | 'logs';
  onTabChange: (tab: 'wallets' | 'logs') => void;
}

const TokenTabs: React.FC<TokenTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex gap-4 mb-6 border-b border-gray-200">
      <button 
        onClick={() => onTabChange('wallets')}
        className={`pb-3 px-4 flex items-center gap-2 font-medium transition-colors border-b-2 ${
          activeTab === 'wallets' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        <Wallet size={18} /> 学员账户总览
      </button>
      <button 
        onClick={() => onTabChange('logs')}
        className={`pb-3 px-4 flex items-center gap-2 font-medium transition-colors border-b-2 ${
          activeTab === 'logs' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
        }`}
      >
        <LayoutList size={18} /> 全校资金流水
      </button>
    </div>
  );
};

export default TokenTabs;
